// John Eldhose 20190108
import { RestfulGet } from './Restful';

export async function getLMDRMAs() {
  const rma = await RestfulGet('getLMDRMAs', (response) => {
      return response['data'];
    }, (error) => {
      console.log(error);
      return false;
    }
  );
  return rma;
}



// WEBPACK FOOTER //
// ./src/Api/getLMDRMAs.js